import { useShortcutBindings } from "./useShortcutBindings.js";

export function useAppShortcuts(bindings) {
  useShortcutBindings(window, bindings);
}
